/** Keep text between a pill's two semicircular ends. */
export function pillPadding(height: number): number {
  return height / 2
}
